<template>
    <div class="px-0 bg-dark position-fixed" id="sidebar">
        <div class="overlay"></div>
        <div
            class="nav flex-column flex-nowrap vh-100 overflow-auto text-white p-2"
        >
            <div class="logo">
                <div class="logo-bg-blur"></div>
                <img src="/images/logo.png" alt="" />
            </div>
            <ul class="menu">
                <router-link to="/admin/dashboard" exact-active-class="active">
                    <li class="text-uppercase">
                        <img src="/images/menu-dashboard.svg" /> Dashboard
                    </li>
                </router-link>
                <router-link to="/admin/vault" exact-active-class="active">
                    <li class="text-uppercase">
                        <img src="/images/menu-vault.svg" /> Vaults
                    </li>
                </router-link>
                    <li class="text-uppercase" @click.prevent="logout" style="cursor:pointer">
                        <img src="/images/log-out.svg" /> Logout
                    </li>            
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            sidebar: true
        };
    },
    mounted() {
        
    },    
    methods: {
          logout() {     
            this.$store
            .dispatch("API", {
                url: `/api/logout`,
            })
            .then((response) => {
                localStorage.removeItem('token')
                this.$router.push({ 
                    name: 'login'
                });
            });              
               
          }     
    }
};
</script>

<style lang="scss">
@import "./resources/sass/app.scss";

.active li {
    background: #262626;
    border-left: 3px solid #6ee29f;
    opacity: 0.6;
}
a {
    text-decoration: none !important;
}

#sidebar {
    background-image: url("/images/admin-bg.jpg") !important;
    background-size: cover !important;
    width: 240px !important;//16.666666666666668vw !important;
    height: 100vh !important;
    overflow: hidden;
    color: #fff;
    position: relative;

    background: radial-gradient(
            58.82% 150.58% at 50% 62.61%,
            rgba(0, 0, 0, 0.2) 0%,
            rgba(0, 13, 23, 0.2) 75%,
            rgba(0, 64, 7, 0.2) 100%
        ),
        linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.05) 26.7%,
            rgba(46, 158, 71, 0.05) 84.52%
        ),
        #171717;
    z-index: 10;

    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 12;
        background: radial-gradient(
                58.82% 150.58% at 50% 62.61%,
                rgba(0, 0, 0, 0.2) 0%,
                rgba(0, 13, 23, 0.2) 75%,
                rgba(0, 64, 7, 0.2) 100%
            ),
            linear-gradient(
                180deg,
                rgba(0, 0, 0, 0.05) 26.7%,
                rgba(46, 158, 71, 0.05) 84.52%
            ),
            #171717 !important;
        width: 100%;
        height: 100%;
        opacity: 0.95;
    }

    .menu {
        /* font-size: 0.9722222222222222vw; // 14px
    line-height: 1.292361111111111vw; // 18.61px */
        font-size: 14px;
        line-height: 18.61px;
        list-style: none;
        padding-left: 0;

        li {
            color: white;
            padding-left: 20px;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            /* height: 2.7777777777777777vw; */
            height: 40px;

            &:hover {
                background: #262626;
                opacity: 0.6;
            }

            img {
                margin-right: 8px;
            }
        }
    }

    .nav {
        z-index: 13;
        position: relative;
        padding: 0 !important;
    }

    .logo {
        position: relative;
        margin-left: auto;
        margin-right: auto;
        margin-top: 30px;
        margin-bottom: 50px;

        a:hover img {
            opacity: 0.7;
        }

        // @media only screen and (min-width: 768px) {
        //     margin-bottom: 70px;
        //     margin-top: 2.7777777777777777vw;
        // }

        // @media only screen and (min-width: 1440px) {
        //     margin-bottom: 4.166666666666667vw;
        // }

        .logo-bg-blur {
            filter: blur(35.5999968px);
            position: absolute;
            width: 129.188px;
            height: 17.594px;
            background: white;
            top: 5%;
            left: 10%;

            // @media only screen and (min-width: 1440px) {
            //     filter: blur(2.472222vw);
            //     width: 8.972222vw;
            //     height: 1.222222vw;
            // }
        }
        img {
            width: 158px;

            // @media only screen and (min-width: 1440px) {
            //     width: 10.972222222222221vw;
            // }
        }
    }
}
</style>
